import { render, staticRenderFns } from "./ApexHeatMapChart.vue?vue&type=template&id=724a9da2"
import script from "./ApexHeatMapChart.vue?vue&type=script&lang=js"
export * from "./ApexHeatMapChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports